<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Interest.s') }}</h1>
          <template v-if="totalCount === 0 || totalCount.to === 1">
            <h2 class="page-subtitle">{{ totalCount }} {{ $t('interest') }}</h2>
          </template>
          <template v-else>
            <h2 class="page-subtitle">{{ totalCount }} {{ $t('interest.s') }}</h2>
          </template>
        </div>
        <b-button class="btn-medium" variant="primary" @click="clickOnCreateBtn">
          <plus-icon class="mr-1" size="18"/>
          {{ $t('Add') }} {{ $t('a.s') }} {{ $t('interest.s') }}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableInvestorInterest"
          :delete-item=isEstateAgent
          :edit-item=isEstateAgent
          :empty-button="$t('interest.emptyButton').toString()"
          :empty-text="$t('interest.emptyText').toString()"
          :empty-title="$t('interest.emptyTitle').toString()"
          :fields="tableFields"
          get-b122-table-results-url="/investorInterest/getB122TableResults"
          identifier="B122TableInvestorInterest"
          init-b122-table-url="/investorInterest/initB122Table"
          @add="clickOnCreateBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn"
          @setTotalCount="setTotalCount">

          <template #cell(contrat)="row">
            <b-link class="main-color underline-text" v-on:click="showContrat(row.item.contrat.id)">
              {{ row.item.contrat.name }}
            </b-link>
          </template>
        </b122-table>
      </b-card>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="true"
      :isFeminine="false"
      :selectedItem="selectedInterest"
      controllerName="investorInterest"
      itemSingularName="intérêt"
      itemSingularNameUpp="Intérêt"
      @didDeleteItem="didDeleteInterest()">
    </Item-delete-modal>
  </div>

</template>

<script>

import B122Table from "../../../components/b122/B122Table";
import ItemDeleteModal from "../../../components/b122/ItemDeleteModal";
import api from "../../../services/api";

export default {
  name: "InvestorInterestIndex",

  components: {
    B122Table,
    ItemDeleteModal
  },

  data() {
    return {
      totalCount: 0,
      totalValue: 0,
      username: this.$store.getters.username,
      isEstateAgent: this.$store.getters.isEstateAgent,
      selectedInterest: null
    }
  },

  computed: {
    tableFields() {
      let tableFields = [
        {
          label: this.$t('interest.Contrat'),
          key: 'contrat',
          sortable: true
        },
        {
          label: this.$t('Bilan'),
          key: 'contrat.bilanType',
          sortable: true
        },
        {
          label: this.$t('interest.Amount'),
          key: 'amount',
          sortable: true,
          formatter: function (value) {
            return Intl.NumberFormat().format((value / 100).toFixed(2)) + " €"
          }
        },
        {
          label: this.$t('interest.dateInterest'),
          key: 'dateInterest',
          sortable: true,
          formatter: function (value) {
            return new Date(value).toLocaleDateString()
          }
        },
        {
          label: '',
          key: 'actions'
        }]
      return tableFields
    }

  },

  methods: {
    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'InvestorInterestCreateEdit',
        params: {
          investorInterestId: null,
          investorContratId: null,
          investorName: null
        }
      })
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'InvestorInterestCreateEdit',
        params: {
          investorInterestId: row.item.id,
          investorContratId: null,
          investorName: null
        }
      })
    },

    showContrat(investorContratId) {
      this.$router.push({
        name: 'InvestorShow',
        params: {
          investorContratId: investorContratId
        }
      })
    },

    clickOnDeleteBtn(row) {
      this.selectedInterest = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteInterest() {
      this.selectedInterest = null
      this.$refs.B122TableInvestorInterest.refreshTable()
    },
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/investor/investorInterest/InvestorInterestIndex.vue